module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', {
    staticClass: "pagenation"
  }, _vm._l((_vm.totalPages), function(page) {
    return _c('span', {
      staticClass: "pagelink",
      class: {
        active: page == _vm.pageNo
      },
      on: {
        "click": function($event) {
          _vm.pageJump(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0aa0ce7f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/archive/pagenation.vue
// module id = 89
// module chunks = 1